export class CreateAsuntoRequest {
    public descripcion: string = "";
}